import { useEffect } from 'react'

interface PersonStructuredDataProps {
    type: 'Person'
}

interface WebSiteStructuredDataProps {
    type: 'WebSite'
}

interface ArticleStructuredDataProps {
    type: 'Article'
    headline: string
    description: string
    datePublished: string
    url: string
    image?: string
}

type StructuredDataProps = PersonStructuredDataProps | WebSiteStructuredDataProps | ArticleStructuredDataProps

export default function StructuredData(props: StructuredDataProps) {
    useEffect(() => {
        let schemaData: object

        if (props.type === 'Person') {
            schemaData = {
                '@context': 'https://schema.org',
                '@type': 'Person',
                'name': 'Rapheal Kwabena Asomani Gadoh',
                'alternateName': ['Rapheal Kwabena', 'Rapheal Gadoh', 'Rapheal Kwabena Asomani Gadoh', 'raphealgadoh'],
                'url': 'https://www.raphealgadoh.me',
                'jobTitle': 'Full Stack Engineer & STEM Innovator',
                'almaMater': 'University of Arkansas Pine Bluff',
                'knowsAbout': [
                    'Full Stack Web Development',
                    'Python Workflow Automation',
                    'React & TypeScript',
                    'Arduino & Embedded Hardware',
                    'STEM Education & Robotics'
                ],
                'sameAs': [
                    'https://github.com/Rapheal-Kwabena',
                    'https://www.linkedin.com/in/younggem',
                    'https://pypi.org/project/pyworkflow-framework/'
                ]
            }
        } else if (props.type === 'WebSite') {
            schemaData = {
                '@context': 'https://schema.org',
                '@type': 'WebSite',
                'name': 'Rapheal Kwabena Portfolio',
                'alternateName': 'Rapheal Kwabena Asomani Gadoh',
                'url': 'https://www.raphealgadoh.me',
                'author': {
                    '@type': 'Person',
                    'name': 'Rapheal Kwabena Asomani Gadoh'
                }
            }
        } else {
            schemaData = {
                '@context': 'https://schema.org',
                '@type': 'BlogPosting',
                'headline': props.headline,
                'description': props.description,
                'datePublished': props.datePublished,
                'mainEntityOfPage': {
                    '@type': 'WebPage',
                    '@id': props.url
                },
                'author': {
                    '@type': 'Person',
                    'name': 'Rapheal Kwabena Asomani Gadoh',
                    'url': 'https://www.raphealgadoh.me'
                },
                'publisher': {
                    '@type': 'Person',
                    'name': 'Rapheal Kwabena Asomani Gadoh',
                    'url': 'https://www.raphealgadoh.me'
                },
                'image': props.image || 'https://www.raphealgadoh.me/og-image.png'
            }
        }

        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.id = `jsonld-${props.type}-${Math.random().toString(36).substr(2, 9)}`
        script.text = JSON.stringify(schemaData)
        document.head.appendChild(script)

        return () => {
            if (document.head.contains(script)) {
                document.head.removeChild(script)
            }
        }
    }, [props])

    return null
}
